export default __webpack_public_path__ + "static/media/sakura.b566cfff.png";